/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuctionCatalogHierarchyDto } from '../models/auction-catalog-hierarchy-dto';
import { AuctionCatalogPartMaterialPriceDto } from '../models/auction-catalog-part-material-price-dto';
import { AuctionCatalogPartStatsDto } from '../models/auction-catalog-part-stats-dto';
import { AuctionCatalogStatsDto } from '../models/auction-catalog-stats-dto';
import { createAuctionCatalogs } from '../fn/auction-catalog/create-auction-catalogs';
import { CreateAuctionCatalogs$Params } from '../fn/auction-catalog/create-auction-catalogs';
import { deleteAuctionCatalog } from '../fn/auction-catalog/delete-auction-catalog';
import { DeleteAuctionCatalog$Params } from '../fn/auction-catalog/delete-auction-catalog';
import { findAuctionCatalogs } from '../fn/auction-catalog/find-auction-catalogs';
import { FindAuctionCatalogs$Params } from '../fn/auction-catalog/find-auction-catalogs';
import { FindAuctionCatalogsResponseDto } from '../models/find-auction-catalogs-response-dto';
import { getAuctionCatalog } from '../fn/auction-catalog/get-auction-catalog';
import { GetAuctionCatalog$Params } from '../fn/auction-catalog/get-auction-catalog';
import { getAuctionCatalogPartMaterialPrices } from '../fn/auction-catalog/get-auction-catalog-part-material-prices';
import { GetAuctionCatalogPartMaterialPrices$Params } from '../fn/auction-catalog/get-auction-catalog-part-material-prices';
import { getAuctionCatalogPartStats } from '../fn/auction-catalog/get-auction-catalog-part-stats';
import { GetAuctionCatalogPartStats$Params } from '../fn/auction-catalog/get-auction-catalog-part-stats';
import { getAuctionCatalogStats } from '../fn/auction-catalog/get-auction-catalog-stats';
import { GetAuctionCatalogStats$Params } from '../fn/auction-catalog/get-auction-catalog-stats';
import { patchAuctionCatalog } from '../fn/auction-catalog/patch-auction-catalog';
import { PatchAuctionCatalog$Params } from '../fn/auction-catalog/patch-auction-catalog';
import { setAuctionCatalogPartMaterialPrices } from '../fn/auction-catalog/set-auction-catalog-part-material-prices';
import { SetAuctionCatalogPartMaterialPrices$Params } from '../fn/auction-catalog/set-auction-catalog-part-material-prices';

@Injectable({ providedIn: 'root' })
export class GeneratedAuctionCatalogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAuctionCatalogs()` */
  static readonly FindAuctionCatalogsPath = '/api/auction-catalogs';

  /**
   * Finds all auction-catalogs for a given auction.
   *
   * NOTE: Does not raise an error if the given auctionId is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAuctionCatalogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAuctionCatalogs$Response(params: FindAuctionCatalogs$Params, context?: HttpContext): Observable<StrictHttpResponse<FindAuctionCatalogsResponseDto>> {
    return findAuctionCatalogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds all auction-catalogs for a given auction.
   *
   * NOTE: Does not raise an error if the given auctionId is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAuctionCatalogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAuctionCatalogs(params: FindAuctionCatalogs$Params, context?: HttpContext): Observable<FindAuctionCatalogsResponseDto> {
    return this.findAuctionCatalogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindAuctionCatalogsResponseDto>): FindAuctionCatalogsResponseDto => r.body)
    );
  }

  /** Path part for operation `createAuctionCatalogs()` */
  static readonly CreateAuctionCatalogsPath = '/api/auction-catalogs';

  /**
   * Creates a new auction-catalogs for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuctionCatalogs()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAuctionCatalogs$Response(params: CreateAuctionCatalogs$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogHierarchyDto>> {
    return createAuctionCatalogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new auction-catalogs for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuctionCatalogs$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAuctionCatalogs(params: CreateAuctionCatalogs$Params, context?: HttpContext): Observable<AuctionCatalogHierarchyDto> {
    return this.createAuctionCatalogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionCatalogHierarchyDto>): AuctionCatalogHierarchyDto => r.body)
    );
  }

  /** Path part for operation `getAuctionCatalog()` */
  static readonly GetAuctionCatalogPath = '/api/auction-catalogs/{id}';

  /**
   * Gets an auction-catalog by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionCatalog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalog$Response(params: GetAuctionCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogHierarchyDto>> {
    return getAuctionCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets an auction-catalog by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionCatalog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalog(params: GetAuctionCatalog$Params, context?: HttpContext): Observable<AuctionCatalogHierarchyDto> {
    return this.getAuctionCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionCatalogHierarchyDto>): AuctionCatalogHierarchyDto => r.body)
    );
  }

  /** Path part for operation `deleteAuctionCatalog()` */
  static readonly DeleteAuctionCatalogPath = '/api/auction-catalogs/{id}';

  /**
   * Deletes an auction-catalogs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuctionCatalog()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteAuctionCatalog$Response(params: DeleteAuctionCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuctionCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an auction-catalogs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuctionCatalog$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteAuctionCatalog(params: DeleteAuctionCatalog$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuctionCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchAuctionCatalog()` */
  static readonly PatchAuctionCatalogPath = '/api/auction-catalogs/{id}';

  /**
   * Patches an auction-catalogs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAuctionCatalog()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAuctionCatalog$Response(params: PatchAuctionCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogHierarchyDto>> {
    return patchAuctionCatalog(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches an auction-catalogs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchAuctionCatalog$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchAuctionCatalog(params: PatchAuctionCatalog$Params, context?: HttpContext): Observable<AuctionCatalogHierarchyDto> {
    return this.patchAuctionCatalog$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionCatalogHierarchyDto>): AuctionCatalogHierarchyDto => r.body)
    );
  }

  /** Path part for operation `getAuctionCatalogStats()` */
  static readonly GetAuctionCatalogStatsPath = '/api/auction-catalogs/{id}/stats';

  /**
   * Gets the statistics of an auction-catalog over all of its parts.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionCatalogStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalogStats$Response(params: GetAuctionCatalogStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogStatsDto>> {
    return getAuctionCatalogStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the statistics of an auction-catalog over all of its parts.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionCatalogStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalogStats(params: GetAuctionCatalogStats$Params, context?: HttpContext): Observable<AuctionCatalogStatsDto> {
    return this.getAuctionCatalogStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionCatalogStatsDto>): AuctionCatalogStatsDto => r.body)
    );
  }

  /** Path part for operation `getAuctionCatalogPartStats()` */
  static readonly GetAuctionCatalogPartStatsPath = '/api/auction-catalogs/{id}/parts/{partId}/stats';

  /**
   * Gets the statistics of a single part of an auction-catalog.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionCatalogPartStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalogPartStats$Response(params: GetAuctionCatalogPartStats$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogPartStatsDto>> {
    return getAuctionCatalogPartStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the statistics of a single part of an auction-catalog.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionCatalogPartStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalogPartStats(params: GetAuctionCatalogPartStats$Params, context?: HttpContext): Observable<AuctionCatalogPartStatsDto> {
    return this.getAuctionCatalogPartStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuctionCatalogPartStatsDto>): AuctionCatalogPartStatsDto => r.body)
    );
  }

  /** Path part for operation `getAuctionCatalogPartMaterialPrices()` */
  static readonly GetAuctionCatalogPartMaterialPricesPath = '/api/auction-catalogs/parts/{partId}/material-prices';

  /**
   * Gets the material prices of an auction catalog part.
   *
   * Lists every material that occurs on a lot of the part, with its binding part material price (if set, #5494) and the material's current display value.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuctionCatalogPartMaterialPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalogPartMaterialPrices$Response(params: GetAuctionCatalogPartMaterialPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>> {
    return getAuctionCatalogPartMaterialPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the material prices of an auction catalog part.
   *
   * Lists every material that occurs on a lot of the part, with its binding part material price (if set, #5494) and the material's current display value.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuctionCatalogPartMaterialPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuctionCatalogPartMaterialPrices(params: GetAuctionCatalogPartMaterialPrices$Params, context?: HttpContext): Observable<Array<AuctionCatalogPartMaterialPriceDto>> {
    return this.getAuctionCatalogPartMaterialPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>): Array<AuctionCatalogPartMaterialPriceDto> => r.body)
    );
  }

  /** Path part for operation `setAuctionCatalogPartMaterialPrices()` */
  static readonly SetAuctionCatalogPartMaterialPricesPath = '/api/auction-catalogs/parts/{partId}/material-prices';

  /**
   * Sets, changes or removes material prices of an auction catalog part.
   *
   * Prices not listed in the request are left untouched; a price of null removes the part material price of that material. A price must be above zero and carry at most four decimal places (#5497). Only a percentage part takes prices.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setAuctionCatalogPartMaterialPrices()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setAuctionCatalogPartMaterialPrices$Response(params: SetAuctionCatalogPartMaterialPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>> {
    return setAuctionCatalogPartMaterialPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Sets, changes or removes material prices of an auction catalog part.
   *
   * Prices not listed in the request are left untouched; a price of null removes the part material price of that material. A price must be above zero and carry at most four decimal places (#5497). Only a percentage part takes prices.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setAuctionCatalogPartMaterialPrices$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setAuctionCatalogPartMaterialPrices(params: SetAuctionCatalogPartMaterialPrices$Params, context?: HttpContext): Observable<Array<AuctionCatalogPartMaterialPriceDto>> {
    return this.setAuctionCatalogPartMaterialPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuctionCatalogPartMaterialPriceDto>>): Array<AuctionCatalogPartMaterialPriceDto> => r.body)
    );
  }

}
